import { IMutation, IMutationWithoutPayload } from '@/store/types/mutation'
import { SHOW_FEEDBACK_FINISH, SHOW_FEEDBACK_INIT } from './mutation-types'
import { FeedbackType, IState } from './types'

interface IShowFeedbackInit {
  message: string,
  feedbackType: FeedbackType
}

const mutationShowFeedbackInit: IMutation<IState, IShowFeedbackInit> = (state, { message, feedbackType }) => {
  state.message = message
  state.feedbackType = feedbackType
  state.isVisible = true
}

const mutationShowFeedbackFinish: IMutationWithoutPayload<IState> = (state) => {
  state.message = ''
  state.feedbackType = FeedbackType.NO_FEEDBACK
  state.isVisible = false
}

export default {
  [SHOW_FEEDBACK_INIT]: mutationShowFeedbackInit,
  [SHOW_FEEDBACK_FINISH]: mutationShowFeedbackFinish,
}
